import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="ba-title" data-id="element-44" data-mp="3ofhx3ds4fjys">
      <div className="mx-auto max-w-5xl" data-id="element-45" data-mp="3sg1vslscevn1">
        <div id="ba-title" data-id="element-46" data-mp="3epybw1gxre0r">
          <SectionHeading title={<>What Changes When You Use <span className="italic text-gold" data-id="element-48" data-mp="3envdou5mqeky">Oral Rehabilitation Blueprint™</span></>} data-id="element-47" data-mp="3epojk78f4urw" />
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-49" data-mp="3jirdwhl0s895">
          <div className="flex flex-col rounded-3xl border-2 border-danger/25 bg-white p-5 sm:p-7" data-id="element-50" data-mp="34stqi3uwzml0">
            <div className="flex items-center gap-3" data-id="element-51" data-mp="39rn2frujz5j2">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-danger text-white" data-id="element-52" data-mp="2vr3uekq37zgw">
                <XIcon aria-hidden="true" className="h-6 w-6" strokeWidth={3} data-id="element-53" data-mp="30px8ofd77ui4" />
              </span>
              <div data-id="element-54" data-mp="x4aexg2ofx2p">
                <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-danger" data-id="element-55" data-mp="x3iqqqbet1mg">Before</p>
                <h3 className="font-serif text-xl font-bold text-navy" data-id="element-56" data-mp="t1x8sqk0px5e">Planning Without a Structured System</h3>
              </div>
            </div>
            <ul className="mt-6 space-y-3" data-id="element-57" data-mp="170dnb3o4gry3">
              {beforeItems.map(t => <li key={t} className="flex gap-3 rounded-xl bg-danger-pale px-4 py-3 text-[15px] leading-snug text-navy" data-id="element-58" data-mp="121k91910gwwv">
                  <XIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-danger" strokeWidth={3} data-id="element-59" data-mp="9ezfq30z6aqo" />
                  <span data-id="element-60" data-mp="o3m04j5glsor">{t}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl border-2 border-cta bg-navy p-5 sm:p-7" data-id="element-61" data-mp="jcnf569j06f6">
            <div className="flex items-center gap-3" data-id="element-62" data-mp="3rspa3hfmov9j">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta text-white" data-id="element-63" data-mp="3rr4f5qpejab5">
                <CheckIcon aria-hidden="true" className="h-6 w-6" strokeWidth={3} data-id="element-64" data-mp="3mrrt386cu79m" />
              </span>
              <div data-id="element-65" data-mp="1qon1nsj8vqzl">
                <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-gold-light" data-id="element-66" data-mp="1vpu6pju06c2k">After</p>
                <h3 className="font-serif text-xl font-bold text-white" data-id="element-67" data-mp="20gsuf4hbmcfu">With Oral Rehabilitation Blueprint™</h3>
              </div>
            </div>
            <ul className="mt-6 space-y-3" data-id="element-68" data-mp="24hmipyyodt99">
              {afterItems.map(t => <li key={t} className="flex gap-3 rounded-xl bg-navy-light px-4 py-3 text-[15px] leading-snug text-white ring-1 ring-white/10" data-id="element-69" data-mp="17t6ovqoj8xqc">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} data-id="element-70" data-mp="1cst0jvopq5x1" />
                  <span data-id="element-71" data-mp="1lreibomd1gwr">{t}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-72" data-mp="2s88diojo5h1b">
          <CtaButton label="I Want a Structured Rehabilitation Roadmap" data-id="element-73" data-mp="2s770wfn08mhh" />
        </div>
      </div>
    </section>;
}